import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const dewPoint_BELOW: typeof valueTypeRenderers.dewPoint_BELOW = {
  label: () => unitConverter.dewPointBelowCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.dewPointBelowCanopy().title(),
      render: (n) => unitConverter.dewPointBelowCanopy(n).valueAsString(),
    }),
}
